/**
 * @generated SignedSource<<d165fec53fab427984300828db6865a9>>
 * @relayHash aa2486e7ead66b97d496e48ba1524c69
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b61dee2518db6b8b6a19d7c91e77ffca8b3a54085863fda904055d5685d9e8db

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GetPersonalSpaceKeyQuery$variables = Record<PropertyKey, never>;
export type GetPersonalSpaceKeyQuery$data = {
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type GetPersonalSpaceKeyQuery = {
  response: GetPersonalSpaceKeyQuery$data;
  variables: GetPersonalSpaceKeyQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "GetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GetPersonalSpaceKeyQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aa2486e7ead66b97d496e48ba1524c69",
    "id": "b61dee2518db6b8b6a19d7c91e77ffca8b3a54085863fda904055d5685d9e8db",
    "metadata": {},
    "name": "GetPersonalSpaceKeyQuery",
    "operationKind": "query",
    "text": "query GetPersonalSpaceKeyQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "a8e2440b035e9c6c70444845a662185b";

export default node;
